import {toggleMark} from 'prosemirror/commands/base';

export const marksKeys = {
  'Mod-b': toggleMark('strong'),
  'Mod-i': toggleMark('em'),
  'Mod-u': toggleMark('underline'),
  'Mod-`': toggleMark('code'),
};